export const environments = {
    UAT: "UAT",
    DEV: "Development",
    PROD: "Production",
    LOCAL: "Local"
};
export const getEnvironment = () => {
    const url = window.location.href;

    if (url.includes("https://online.mascom.bw")) {
        return environments.PROD;
    }
    if (url.includes("https://eportaluat.mascom.bw")) {
        return environments.UAT;
    }
    if (url.includes("https://mascom.entelectprojects.co.za")) {
        return environments.DEV;
    }

    return environments.LOCAL;
};
